import React__default from 'react';
import QsrOrderStatus from '../../../../Molecules/QsrOrderStatus.js';
import QsrBillBreakup from '../../../../Cells/BillBreakup.js';

function QsrOrderSuccessShimmer() {
    return (React__default.createElement("div", { className: "qsr-order-success" },
        React__default.createElement("div", { className: "qsr-order-success__header" },
            React__default.createElement(QsrOrderStatus, { loading: true })),
        React__default.createElement("div", { className: "qsr-order-success__body" },
            React__default.createElement(QsrBillBreakup, { loading: true, tokenNo: 0, items: [] }))));
}

export { QsrOrderSuccessShimmer as default };
//# sourceMappingURL=index.shimmer.js.map
